'use client';

import { FooterLinks } from "@/app/components";
import { useSite } from '@/lib/site-context';
import { Sparkles } from 'lucide-react';
import './StatusBar.scss';

interface StatusBarProps {
  sketchTitle: string;
  canEdit: boolean;
  lineCount: number;
  lastSaved?: Date;
  aiEnabled?: boolean;
  onAiClick?: () => void;
}

export default function StatusBar({
  sketchTitle,
  canEdit,
  lineCount,
  lastSaved,
  aiEnabled = false,
  onAiClick,
}: StatusBarProps) {
  const site = useSite();
  const footerCopyYear = new Date().getFullYear().toString();
  const footerCopyText = site.id === 'py'
    ? `© ${footerCopyYear} py2g. python to gcode`
    : `© ${footerCopyYear} js2g. javascript to gcode`;

  return (
    <div className="status-bar">
      <div className="status-left">
        {sketchTitle} - {canEdit ? 'Owner' : 'View Only'}
        {' | '}
        <span>Lines: {lineCount}</span>
        {' | '}
        {lastSaved && (
          <span>Last saved: {lastSaved.toLocaleTimeString()}</span>
        )}
        {aiEnabled && onAiClick && (
          <>
            {' | '}
            <button
              onClick={onAiClick}
              className="ai-button"
              title="AI Assistant"
            >
              <Sparkles size={14} />
              <span>AI Assistant</span>
            </button>
          </>
        )}
      </div>
      <div className="status-right">
        {footerCopyText}
        <FooterLinks />
      </div>
    </div>
  );
}